module.exports = __webpack_public_path__ + "static/scale-model-of-kern-travel-in-bakersfield-california-48eeea436792c7ffec08ccd85d4e924f.png";